import { autoRegisterFeature } from '@store/features/factory';
import { formsFeature } from './store/feature';

// Auto-register the feature
autoRegisterFeature(formsFeature);

// Export everything
export * from './store';
export * from './types';
// Note: Form library components have been moved to form-library feature
